import React, { useContext } from "react";
import Logo from "../../assets/logoRed.png";
import "./style.css";
import { UserContext } from "../../providers/UserProvider";
import { Button } from "react-bootstrap";

const AfterSignupPage = () => {
  const [newMail, setNewMail] = React.useState("none");
  const user = useContext(UserContext);
  console.log("user: ", user);
  console.log("verified?: ", user.emailVerified);
  const handleClick = () => {
              user.sendEmailVerification({
                url: "http://localhost:3000/ProfileUpdate",
              });
              setNewMail("block");
            }
  return (
    <div className="thankyou-wrapper">
      <div className="thankyou-content">
        <a style={{ textAlign: "center" }} href="MainPage">
          {" "}
          <img
            src={Logo}
            className="img-responsive"
            style={{ width: "100px" }}
            alt="Logo"
          />
        </a>
        <hr style={{ position: "fixed" }} />
        <h1
          style={{
            marginTop: "20px",
            marginRight: "20px",
            textAlign: "center",
          }}
        >
          Lawyerz תודה ענקית מצוות
        </h1>
        <p className="thankyou-p">
          תודה על הצטרפותכם! יישלח אליכם לדואר מייל אקטיבציה, תעקבו אחרי ההוראות
          שם.
        </p>
        <div>
          <p className="thankyou-p">
            אם לא קיבלתם מייל בדקות הקרובות, אנא בדקו תיבת דואר Spam או לשליחה
            שוב:{" "}
          </p>
          <Button
            variant="success"
            onClick={handleClick}
          >
            לשליחה שוב
          </Button>
          <p style={{ display:  newMail  }} className="thankyou-p">
            נשלח מייל חדש.{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AfterSignupPage;
